import { tv } from '@eluve/components';

export const appointmentLayoutStyles = tv({
  base: 'mx-auto max-w-[1024px] flex-1 p-2 sm:gap-5',
});
